import React from 'react'
import { storiesOf } from '@storybook/react'

import Typography from '@material-ui/core/Typography'

import Coin from 'components/Coin'
import Countdown from 'components/Countdown'
import GameCardScores from 'components/GameCard/components/GameCardScores'

const currencyStyle: React.CSSProperties = {
  fontSize: 10,
  fontWeight: 500,
}

const columns = [{
  value: (<Typography style={{ fontSize: 16, fontWeight: 500 }}><Countdown remainingSec={2 * 60 * 60} /></Typography>),
  label: 'starts in',
}, {
  value: (<Coin value={1000} style={{ fontSize: 16, fontWeight: 500 }} currencyStyle={currencyStyle} />),
  label: 'entry fee',
}, {
  value: (<Coin value={9500} style={{ fontSize: 16, fontWeight: 500 }} currencyStyle={currencyStyle} />),
  label: 'first prize',
}]

storiesOf('GameCard/GameCardScores', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#DDD' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#DDD', width: 320, borderTop: '1px solid white' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <GameCardScores columns={columns} />
  ))
  .add('rounded', () => (
    <GameCardScores columns={columns} rounded />
  ))
